import { Injectable } from '@angular/core';
import { GblReferenceModel, GeneralResModel } from 'src/app/_models';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class ReferenceService {
  private apiPATH = `setup/GetActiveReferenceType/`;

  constructor(private _api: ApiService) {}

  getActiveReferenceType(referenceType: string, orgId?: number) {
    if (orgId) {
      this.apiPATH = `setup/GetActiveReferenceType/${referenceType}/${orgId}/`;
    } else {
      this.apiPATH = `setup/GetActiveReferenceType/${referenceType}`;
    }

    return this._api.get<GeneralResModel<GblReferenceModel[]>>(
      `${this.apiPATH}`,
    );
  }
}
